import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["input"]

  connect() {
    this.timeout = null
  }

  submit(event) {
    clearTimeout(this.timeout)

    this.timeout = setTimeout(() => {
      event.target.form.requestSubmit()
    }, 300)
  }
}